export default __webpack_public_path__ + "static/media/Group 2139.ddc2953e.svg";